import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PasswordInput from '../components/PasswordInput';

export default function ForgotPage() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { forgotPassword, resetPassword } = useAuth();
  const navigate = useNavigate();

  const handleSend = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await forgotPassword(email);
      setStep(2);
    } catch (err) {
      setError(err || 'Could not send reset email');
    } finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await resetPassword(email, code, password);
      navigate('/login', { state: { message: 'Password reset! You can now sign in.' } });
    } catch (err) {
      setError(err || 'Could not reset password');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">🔑</div>
          <div className="auth-title">{step === 1 ? 'Reset Password' : 'Enter New Password'}</div>
          <div className="auth-subtitle">{step === 1 ? 'Enter your email to receive a reset code' : 'Check your email for the code'}</div>
        </div>
        {error && <div className="error-msg" style={{marginBottom:16}}>{error}</div>}
        {step === 1 ? (
          <form className="auth-form" onSubmit={handleSend}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input className="form-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send Reset Code'}
            </button>
          </form>
        ) : (
          <form className="auth-form" onSubmit={handleReset}>
            <div className="form-group">
              <label className="form-label">Reset Code (from email)</label>
              <input className="form-input" type="text" value={code}
                onChange={e => setCode(e.target.value)} placeholder="6-digit code"
                style={{fontFamily:'monospace', letterSpacing:'0.15em'}} required />
            </div>
            <div className="form-group">
              <label className="form-label">New Password</label>
              <PasswordInput className="form-input" value={password}
                onChange={e => setPassword(e.target.value)} placeholder="Min 8 chars" required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset Password'}
            </button>
          </form>
        )}
        <div className="auth-footer"><Link to="/login">← Back to sign in</Link></div>
      </div>
    </div>
  );
}
